import React from "react";
import * as Mui from "@mui/material";
import { Chart } from "./chart";
import { connect } from "react-redux";
import { RootState } from "redux/store";
import { getActiveLeads, getLeadsByUnassignedAgent } from "redux/selector";
import { LoadingIndicator } from "component/shared/loading-indicator";
import { getLeadsByAgentId } from "redux/selector";
import { AppCard } from "component/shared/app-card";


const mapStateToProps = (state: RootState) => {
	const agentId = state.agents.value;
	const unassigned = agentId === -1
	return {
		leads: getActiveLeads(state),
		loading: state.leads.loading,
		leadsByAgent: getLeadsByAgentId(state, agentId),
		leadsByUnassigned: getLeadsByUnassignedAgent(state),
		agentId,
		unassigned
	}
}

interface Props extends ReturnType<typeof mapStateToProps> {}

class Component extends React.Component<Props> {
	public render() {
		const { loading, leadsByAgent, agentId, leadsByUnassigned, unassigned } = this.props;
		const leads = unassigned ? leadsByUnassigned : this.props.leads;
		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item>
					<Mui.Grid container justifyContent="space-between">
						<Mui.Grid item>
							<Mui.Typography variant="h3">% with Activity</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item>
							<Mui.Typography variant="h6">* Past 30 days</Mui.Typography>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
				<Mui.Grid item>
					<AppCard><Mui.CardContent style={{ height: 200 }}>
							{!!loading && (
								<Mui.Grid container justifyContent="center" alignItems="center" direction="row"> 
									<Mui.Grid item>
										<LoadingIndicator />
									</Mui.Grid>
								</Mui.Grid>
							)}
							{!loading && leads.length ?
								<Chart leads={!agentId ? leads : leadsByAgent} />
							: 
								<Mui.Grid container alignItems="center" style={{ height: "100%" }}>
									<Mui.Grid item>
										<Mui.Typography align="center">Start adding leads to see this chart.</Mui.Typography>
									</Mui.Grid>
								</Mui.Grid>
							}
					</Mui.CardContent></AppCard>
				</Mui.Grid>
			</Mui.Grid>
		);
	}

}

export const PercentWithActivity = connect(mapStateToProps)(Component);